import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TopNavigation from './TopNavigation';
import BottomNavigation from './BottomNavigation';
import FeedbackBox from './FeedbackBox';
import './FeedbackPage.css';

const FeedbackPage = () => {
  const navigate = useNavigate();

  return (
    <div className="feedback-page-container">
      <TopNavigation activePage="feedback" />
      
      <main className="feedback-page-main">
        <FeedbackBox 
          isOpen={true} 
          onClose={() => navigate(-1)} 
          isPageMode={true}
        />
      </main>

      <BottomNavigation />
    </div>
  );
};

export default FeedbackPage;
